export enum OrganizationStatus {
  ACTIVE,
  UPDATED,
  INACTIVE,
  DELETED,
  PENDING,
}

export type Organization = {
  id?: string;
  name: string;
  description: string;
  status: OrganizationStatus;
  url: string;
  parentOrganization?: Organization;
  childOrganizations?: Organization[];
};
export default Organization;
